import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Col,
  Table,
  Input,
  Label,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Swal from "sweetalert2";
import SelectorArchivos, { subirEnSerie, avisaResultado, nombreDe } from "../../SelectorArchivos";
import axios from "axios";
import moment from "moment";

function ListadoSolicitudesPago() {
  const { user } = useContext(AuthContext);
  const URL_SOLICITUDES_PAGO = process.env.REACT_APP_URL_SOLICITUDES_PAGO;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [solicitudes, setSolicitudes] = useState([]);
  const [selectedEstado, setSelectedEstado] = useState("");
  const [selectedClasificacion, setSelectedClasificacion] = useState("");

  // Ejecución: el banco de donde sale el dinero y el TC real se definen aquí
  const [bancos, setBancos] = useState([]);
  const [modalEjecutar, setModalEjecutar] = useState(false);
  const [solEjecutar, setSolEjecutar] = useState(null);
  const [bancoEjecutar, setBancoEjecutar] = useState("");
  const [tcEjecutar, setTcEjecutar] = useState(1);
  const [comprobante, setComprobante] = useState([]);

  // Archivos de la solicitud (comprobante de pago)
  const [modalArchivos, setModalArchivos] = useState(false);
  const toggleArchivos = () => setModalArchivos(!modalArchivos);
  const [solArchivos, setSolArchivos] = useState({});
  const [listaArchivos, setListaArchivos] = useState([]);
  const [archivoNuevo, setArchivoNuevo] = useState([]);
  const [subiendo, setSubiendo] = useState(false);
  const [ejecutando, setEjecutando] = useState(false);

  const nombreUsuario = `${user?.nombre || ""} ${user?.apellido || ""}`.trim();

  const headersAuth = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const cargar = () => {
    axios
      .get(URL_SOLICITUDES_PAGO, { headers: headersAuth })
      .then((r) => setSolicitudes(r.data || []))
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    cargar();
    axios
      .get(URL_BANCOS, { headers: headersAuth })
      .then((r) => setBancos((r.data || []).filter((b) => b.is_active !== "No")))
      .catch((e) => console.log(e));
  }, []);

  const monedaFmt = (n, mon) =>
    new Intl.NumberFormat(mon === "USD" ? "en-US" : "es-MX", {
      style: "currency",
      currency: mon === "USD" ? "USD" : "MXN",
    }).format(Number(n) || 0);

  const clasifLabel = (c) =>
    c === "Proveedor"
      ? "Proveedor / Producto"
      : c === "Gasto"
      ? "Gasto Operativo"
      : c === "Traspaso"
      ? "Traspaso Interno"
      : c;

  const badgeEstado = (e) => {
    const map = {
      Solicitada: "warning",
      Autorizada: "info",
      Ejecutada: "success",
      Rechazada: "danger",
    };
    return (
      <Badge color={map[e] || "secondary"} pill>
        {e}
      </Badge>
    );
  };

  const log = (tipo, detalle) =>
    axios.post(URL_LOGS, { tipo, detalle, user: user.id }, { headers: headersAuth });

  function autorizar(s) {
    Swal.fire({
      title: "¿Autorizar la solicitud?",
      text: `#${s.idSolicitudPago} · ${clasifLabel(s.clasificacion)} · ${monedaFmt(
        s.monto,
        s.moneda
      )}`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Sí, autorizar",
      cancelButtonText: "Cancelar",
    }).then((res) => {
      if (!res.isConfirmed) return;
      axios
        .patch(
          `${URL_SOLICITUDES_PAGO}Autorizar/${s._id}`,
          { autoriza: nombreUsuario },
          { headers: headersAuth }
        )
        .then(() => {
          log("Autorizar Solicitud Pago", `#${s.idSolicitudPago}`);
          Swal.fire("¡Listo!", "Solicitud autorizada", "success");
          cargar();
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            footer: `${error?.response?.data || ""}`,
          });
        });
    });
  }

  function rechazar(s) {
    Swal.fire({
      title: "¿Rechazar la solicitud?",
      input: "text",
      inputLabel: "Motivo del rechazo",
      inputPlaceholder: "Escribe el motivo",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Rechazar",
      cancelButtonText: "Cancelar",
    }).then((res) => {
      if (!res.isConfirmed) return;
      axios
        .patch(
          `${URL_SOLICITUDES_PAGO}Rechazar/${s._id}`,
          { autoriza: nombreUsuario, motivoRechazo: res.value || "" },
          { headers: headersAuth }
        )
        .then(() => {
          log("Rechazar Solicitud Pago", `#${s.idSolicitudPago}`);
          Swal.fire("Listo", "Solicitud rechazada", "success");
          cargar();
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            footer: `${error?.response?.data || ""}`,
          });
        });
    });
  }

  // Abre el modal donde tesorería elige el banco y confirma el tipo de cambio real
  function ejecutar(s) {
    setSolEjecutar(s);
    setBancoEjecutar(s.bancos?.[0]?._id || "");
    setTcEjecutar(Number(s.tipoCambio) || 1);
    setComprobante([]);
    setModalEjecutar(true);
  }

  function abreArchivos(s) {
    setSolArchivos(s);
    setListaArchivos(s.archivos || []);
    setArchivoNuevo([]);
    toggleArchivos();
  }

  async function subeArchivo() {
    if (!archivoNuevo.length) {
      Swal.fire({ icon: "error", title: "Elige primero los archivos o la carpeta" });
      return;
    }
    setSubiendo(true);
    const resultado = await subirEnSerie(
      archivoNuevo,
      (archivo, nombre) => {
        const formData = new FormData();
        formData.append("file", archivo);
        formData.append("nombre", nombre);
        formData.append("user", user.id);
        return axios.post(`${URL_SOLICITUDES_PAGO}Archivo/${solArchivos._id}`, formData, {
          headers: headersAuth,
        });
      },
      `Subiendo a la solicitud ${solArchivos.idSolicitudPago || ""}`
    );
    setSubiendo(false);
    if (resultado.ultimaRespuesta) {
      setListaArchivos(resultado.ultimaRespuesta.data?.archivos || []);
      cargar();
    }
    setArchivoNuevo(archivoNuevo.filter((f) => resultado.fallidos.some((x) => x.nombre === nombreDe(f))));
    avisaResultado(
      resultado,
      solArchivos.pagosProveedores ? "También quedaron en el pago a proveedor." : ""
    );
  }


  function confirmarEjecutar() {
    if (!solEjecutar) return;
    if (!bancoEjecutar) {
      Swal.fire({ icon: "error", title: "Selecciona el banco de donde sale el pago" });
      return;
    }
    if (!(Number(tcEjecutar) > 0)) {
      Swal.fire({ icon: "error", title: "Captura un tipo de cambio válido" });
      return;
    }
    setEjecutando(true);
    axios
      .patch(
        `${URL_SOLICITUDES_PAGO}Ejecutar/${solEjecutar._id}`,
        { bancos: bancoEjecutar, tipoCambio: Number(tcEjecutar) },
        { headers: headersAuth }
      )
      .then(async () => {
        log("Ejecutar Solicitud Pago", `#${solEjecutar.idSolicitudPago}`);
        // El comprobante se sube despues de ejecutar: asi queda ligado tambien
        // al pago a proveedor que acaba de generarse
        let resultado = null;
        if (comprobante.length) {
          resultado = await subirEnSerie(
            comprobante,
            (archivo, nombre) => {
              const formData = new FormData();
              formData.append("file", archivo);
              formData.append("nombre", nombre);
              formData.append("user", user.id);
              return axios.post(`${URL_SOLICITUDES_PAGO}Archivo/${solEjecutar._id}`, formData, {
                headers: headersAuth,
              });
            },
            "Pago ejecutado · subiendo comprobante"
          );
        }
        setEjecutando(false);
        setModalEjecutar(false);
        setComprobante([]);
        cargar();
        if (resultado && resultado.fallidos.length) {
          // Antes este aviso se tapaba con el de "Listo" y nadie lo veia
          await avisaResultado(resultado, "");
          Swal.fire({
            icon: "info",
            title: "El pago sí se ejecutó",
            text: "Los comprobantes que fallaron los puedes subir desde el botón de archivos del listado.",
          });
        } else {
          Swal.fire("¡Listo!", "Solicitud ejecutada", "success");
        }
      })
      .catch((error) => {
        setEjecutando(false);
        Swal.fire({
          icon: "error",
          title: "No se pudo ejecutar",
          footer: `${error?.response?.data || ""}`,
        });
      });
  }

  const filtradas = useMemo(() => {
    let arr = [...solicitudes].filter((s) => s.is_active !== "No");
    if (selectedEstado) arr = arr.filter((s) => s.estado === selectedEstado);
    if (selectedClasificacion)
      arr = arr.filter((s) => s.clasificacion === selectedClasificacion);
    return arr.sort((a, b) =>
      (a.fecha || "") < (b.fecha || "") ? 1 : -1
    );
  }, [solicitudes, selectedEstado, selectedClasificacion]);

  const puedeAutorizar = user.solicitudes_autorizar;
  const puedeEjecutar = user.solicitudes_ejecutar;

  return (
    <>
      <Header />
      <br />
      <br />
      {user.bancos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button title="Capturar una nueva solicitud de pago"
                size="sm"
                className="btn btn-success"
                href="/SolicitudesPagoCreate"
              >
                Nueva Solicitud
              </Button>{" "}
              <Button title="Regresar al menu" size="sm" className="btn btn-danger" href="/MenuCXP">
                Regresar
              </Button>
            </Col>
          </Row>
          <h3 align="center">Solicitudes de Pago</h3>
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Estado</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedEstado}
                onChange={(e) => setSelectedEstado(e.target.value)}
              >
                <option value="">Todos</option>
                <option value="Solicitada">Solicitada</option>
                <option value="Autorizada">Autorizada</option>
                <option value="Ejecutada">Ejecutada</option>
                <option value="Rechazada">Rechazada</option>
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Clasificación</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedClasificacion}
                onChange={(e) => setSelectedClasificacion(e.target.value)}
              >
                <option value="">Todas</option>
                <option value="Proveedor">Proveedor / Producto</option>
                <option value="Gasto">Gasto Operativo</option>
                <option value="Traspaso">Traspaso Interno</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <thead>
              <tr>
                <th>#</th>
                <th>Fecha</th>
                <th>Clasificación</th>
                <th>Concepto</th>
                <th>Destino</th>
                <th className="text-right">Monto</th>
                <th>Banco</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filtradas.map((s) => {
                // Para pagos a proveedor se muestra también a qué se aplica
                // (OC / embarque / concepto de pago)
                const aplicaA = [
                  s.ordenesCompra?.idOrdenCompra
                    ? `OC ${s.ordenesCompra.idOrdenCompra}`
                    : "",
                  s.embarques?.idEmbarques
                    ? `EMB #${s.embarques.idEmbarques}${
                        s.embarques.contenedor ? ` ${s.embarques.contenedor}` : ""
                      }`
                    : "",
                  s.conceptosPago?.concepto || "",
                ]
                  .filter(Boolean)
                  .join(" · ");
                const destino =
                  s.clasificacion === "Proveedor"
                    ? [s.proveedores?.[0]?.nombre_comercial || "", aplicaA]
                        .filter(Boolean)
                        .join(" · ")
                    : s.clasificacion === "Gasto"
                    ? s.categorias?.[0]?.name || ""
                    : s.clasificacion === "Traspaso"
                    ? `→ ${s.bancoDestino?.banco || ""} ${
                        s.bancoDestino?.cuenta || ""
                      }`
                    : "";
                return (
                  <tr key={s._id}>
                    <td>{s.idSolicitudPago}</td>
                    <td style={{ minWidth: 90 }}>{s.fecha}</td>
                    <td>{clasifLabel(s.clasificacion)}</td>
                    <td>{s.concepto}</td>
                    <td>{destino}</td>
                    <td className="text-right">
                      {monedaFmt(s.monto, s.moneda)}
                    </td>
                    <td>
                      {s.bancos?.[0]?.banco || ""} {s.bancos?.[0]?.cuenta || ""}
                    </td>
                    <td>
                      {badgeEstado(s.estado)}
                      {s.estado === "Rechazada" && s.motivoRechazo ? (
                        <div style={{ fontSize: 11, color: "#94a3b8" }}>
                          {s.motivoRechazo}
                        </div>
                      ) : null}
                    </td>
                    <td style={{ minWidth: 200 }}>
                      {s.estado === "Solicitada" && puedeAutorizar ? (
                        <>
                          <Button title="Autorizar la solicitud (le avisa a Oyuki para hacer la transferencia)"
                            size="sm"
                            color="success"
                            onClick={() => autorizar(s)}
                          >
                            <i class="fas fa-check"></i> Autorizar
                          </Button>{" "}
                          <Button title="Rechazar la solicitud (pide el motivo)"
                            size="sm"
                            color="danger"
                            onClick={() => rechazar(s)}
                          >
                            <i class="fas fa-times"></i>
                          </Button>
                        </>
                      ) : null}
                      {s.estado === "Autorizada" && puedeEjecutar ? (
                        <Button title="Ejecutar: registrar la transferencia con su comprobante y el banco de origen"
                          size="sm"
                          color="primary"
                          onClick={() => ejecutar(s)}
                        >
                          <i class="fas fa-play"></i> Ejecutar
                        </Button>
                      ) : null}
                      {s.estado === "Ejecutada" ? (
                        <span style={{ fontSize: 12, color: "#15803d" }}>
                          <i class="fas fa-check-circle"></i> Aplicada
                        </span>
                      ) : null}{" "}
                      <Button
                        size="sm"
                        color="secondary"
                        title="Comprobantes de esta solicitud"
                        onClick={() => abreArchivos(s)}
                      >
                        <i class="fas fa-paperclip"></i>
                        {s.archivos && s.archivos.length
                          ? ` ${s.archivos.length}`
                          : ""}
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      ) : undefined}

      {/* Ejecución: aquí tesorería define de qué banco sale y el TC real */}
      <Modal size="md" isOpen={modalEjecutar} toggle={() => setModalEjecutar(!modalEjecutar)}>
        <ModalHeader toggle={() => setModalEjecutar(!modalEjecutar)}>
          Ejecutar solicitud {solEjecutar ? `#${solEjecutar.idSolicitudPago}` : ""}
        </ModalHeader>
        <ModalBody>
          {solEjecutar ? (
            <>
              <div style={{ fontSize: 13, color: "#64748b" }} className="mb-3">
                {clasifLabel(solEjecutar.clasificacion)} ·{" "}
                <strong>{monedaFmt(solEjecutar.monto, solEjecutar.moneda)}</strong>
                {solEjecutar.concepto ? ` · ${solEjecutar.concepto}` : ""}
                <br />
                Se generará el movimiento real. Esta acción afecta saldos.
              </div>
              <Label className="mr-sm-2">Banco de donde sale el pago</Label>
              <Input
                type="select"
                value={bancoEjecutar}
                onChange={(e) => setBancoEjecutar(e.target.value)}
              >
                <option value="">Selecciona</option>
                {bancos
                  .filter((b) =>
                    solEjecutar.clasificacion === "Traspaso"
                      ? b._id !== solEjecutar.bancoDestino?._id
                      : true
                  )
                  .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                  .map((b) => (
                    <option value={b._id}>
                      {b.banco} {b.cuenta} ({b.moneda})
                    </option>
                  ))}
              </Input>
              <Label className="mr-sm-2 mt-3">Tipo de Cambio</Label>
              <Input
                type="number"
                step="any"
                min="0"
                value={tcEjecutar}
                onChange={(e) => setTcEjecutar(e.target.value)}
              />
              <div style={{ fontSize: 12, color: "#94a3b8" }} className="mt-1">
                Ajusta el tipo de cambio real del día si es distinto al solicitado.
              </div>
              <Label className="mr-sm-2 mt-3">Comprobante de pago</Label>
              <SelectorArchivos
                archivos={comprobante}
                onChange={setComprobante}
                deshabilitado={ejecutando}
              />
              <div style={{ fontSize: 12, color: "#94a3b8" }} className="mt-1">
                Opcional. Queda en esta solicitud y, si es pago a proveedor,
                también en el pago.
              </div>
            </>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button title="Cerrar sin ejecutar" color="secondary" onClick={() => setModalEjecutar(false)}>
            Cancelar
          </Button>
          <Button title="Registrar el pago y avisar a B2B" color="primary" onClick={confirmarEjecutar} disabled={ejecutando}>
            {ejecutando ? "Ejecutando..." : "Ejecutar"}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="md" isOpen={modalArchivos} toggle={toggleArchivos}>
        <ModalHeader toggle={toggleArchivos}>
          Comprobantes de la solicitud{" "}
          {solArchivos ? `#${solArchivos.idSolicitudPago}` : ""}
        </ModalHeader>
        <ModalBody>
          <div style={{ fontSize: 12, color: "#64748b" }}>
            {clasifLabel(solArchivos.clasificacion)} ·{" "}
            {monedaFmt(solArchivos.monto, solArchivos.moneda)}
            {solArchivos.pagosProveedores
              ? " · ligada a un pago a proveedor"
              : ""}
          </div>
          <br />
          {listaArchivos.length ? (
            <Table size="sm" borderless>
              <thead>
                <tr>
                  <th style={{ fontSize: 12 }}>Archivo</th>
                  <th style={{ fontSize: 12 }}>Fecha</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {listaArchivos.map((f, i) => (
                  <tr key={f.public_id || i}>
                    <td style={{ fontSize: 12 }}>{f.nombre}</td>
                    <td style={{ fontSize: 12 }}>{f.fecha}</td>
                    <td>
                      <a
                        href={f.url}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-info btn-sm"
                      >
                        Abrir
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div style={{ fontSize: 12, color: "#94a3b8" }}>
              Esta solicitud no tiene comprobantes todavía.
            </div>
          )}
          <br />
          <Label className="mr-sm-2" style={{ fontSize: 12 }}>
            Agregar comprobantes o una carpeta
          </Label>
          <SelectorArchivos
            archivos={archivoNuevo}
            onChange={setArchivoNuevo}
            deshabilitado={subiendo}
          />
        </ModalBody>
        <ModalFooter>
          <Button title="Subir los archivos elegidos" color="primary" onClick={subeArchivo} disabled={subiendo}>
            {subiendo
              ? "Subiendo..."
              : archivoNuevo.length > 1
              ? `Subir ${archivoNuevo.length} archivos`
              : "Subir"}
          </Button>
          <Button title="Cerrar" color="secondary" onClick={toggleArchivos}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoSolicitudesPago;
